import React from 'react';
import { List, Typography } from 'antd';
import ToolbarItem from './ToolbarItem';
import { FormElements } from './formItems';
import styles from './styles.module.pcss';

export type ToolboxFormItem = {
  label: string;
  type: string;
  withOptions?: boolean;
  component: any;
};

const Toolbar = () => {
  const toolboxItems = Array.from(FormElements, ([name, data]) => ({ name, data }));
  return (
    <List
      header={<Typography.Title level={4}>Toolbox</Typography.Title>}
      bordered
      dataSource={toolboxItems}
      renderItem={(item) => <ToolbarItem formItem={item.data} />}
      className={styles.toolbar}
    />
  );
};

export default Toolbar;
